import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

export default function CompanyPurchaseCard({ company }) {
    const location = useLocation();
    const [ failedLogo, setFailedLogo ] = useState(null);

    return (
      <article className="purchase-company-card">
        <div className="purchase-company-row">
          <span className="purchase-company-logo" aria-hidden="true">
            {company.companyLogo && failedLogo !== company.companyLogo
                ? <img src={company.companyLogo} alt="" loading="lazy" onError={() => setFailedLogo(company.companyLogo)} />
                : <span>{company.companyName.trim().charAt(0).toUpperCase() || 'C'}</span>}
          </span>
          <div className="purchase-company-identity">
            <h2 className="purchase-company-name">{company.companyName}</h2>
            <span className="purchase-company-metadata">
              <span className="purchase-company-customer"><i className="fa fa-user-o" aria-hidden="true" />Customer ID: {company.custId || '—'}</span>
              <span><i className="fa fa-building-o" aria-hidden="true" />Central company ID: {company.centralCompanyId}</span>
            </span>
          </div>
          <Link className="purchase-view-button" to={`/companies/${company.centralCompanyId}/purchases`}
            state={{ companyListSearch: location.search, company: { centralCompanyId: company.centralCompanyId, companyName: company.companyName, custId: company.custId } }}
            aria-label={`View purchases for ${company.companyName}`}>View purchases <span aria-hidden="true">→</span></Link>
        </div>
      </article>
    );
}

CompanyPurchaseCard.propTypes = {
    company: PropTypes.shape({
        centralCompanyId: PropTypes.number.isRequired,
        companyName: PropTypes.string.isRequired,
        custId: PropTypes.string,
        companyLogo: PropTypes.string,
        purchases: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
};
